import React from 'react'
import './NoRecordsFound.css'
import { useTranslation } from 'react-i18next'
function NoRecordsFound(props) {
    const { t } = useTranslation()
    return (
        <h4 className="noRecordsFound">
            <span className="material-icons">find_in_page</span>
            {props?.text
                ? props.text
                : global.storeDetails?.theme == 20
                ? 'Oops! Nothing Found.'
                : t('No_Records')}
        </h4>
    )
}

export default NoRecordsFound
